import type { CustomerEditViewModel } from "@payping/api";
import { getCustomerInfo, updateCustomer } from "@payping/redux/actions";
import { useMessagedAsyncFn } from "@payping/web-components";
import { FC } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useAsyncRetry } from "react-use";
import { useAppDispatch } from "@/utils/redux";
import { useAppTranslation } from "@/utils/useAppTranslation";
import CustomerForm from "./form";
import { LocationStateSearch } from "./types";

const Edit: FC = () => {
  const location = useLocation();
  const locationSearch = (location.state as LocationStateSearch)?.locationSearch;
  const { code } = useParams<{ code: string }>() as { code: string };
  const dispatch = useAppDispatch();
  const { t } = useAppTranslation();
  const { loading: loadingGet, value: details } = useAsyncRetry(
    () => dispatch(getCustomerInfo(code)),
    [code, dispatch],
  );

  const [{ loading: loadingEdit }, handleEdit] = useMessagedAsyncFn(
    async (customerData: CustomerEditViewModel): Promise<void> => {
      try {
        await dispatch(updateCustomer(customerData.code, customerData));
      } catch {
        /* empty */
      }
    },
    [dispatch],
    undefined,
    { success: false },
  );

  const loading = loadingGet || loadingEdit;

  return (
    <CustomerForm
      title={t("customer.edit.title")}
      loading={loading}
      details={details}
      onOk={(param) => handleEdit(param as CustomerEditViewModel)}
      locationSearch={locationSearch}
    />
  );
};

export default Edit;
